export default {
  name: 'click-outside',
  beforeMount: (el, binding) => {
    // eslint-disable-next-line
    el.eventSetDrag = () => {
      el.setAttribute('data-dragging', 'yes');
    };

    // eslint-disable-next-line
    el.eventClearDrag = () => {
      el.removeAttribute('data-dragging');
    };

    // eslint-disable-next-line
    el.eventOnClick = (event) => {
      const dragging = el.getAttribute('data-dragging');

      if (!(el === event.target || el.contains(event.target)) && !dragging) {
        binding.value(event, el);
      }
    };

    document.addEventListener('touchstart', el.eventClearDrag);
    document.addEventListener('touchmove', el.eventSetDrag);
    document.addEventListener('click', el.eventOnClick);
  },
  unmounted: (el) => {
    document.removeEventListener('touchstart', el.eventClearDrag);
    document.removeEventListener('touchmove', el.eventSetDrag);
    document.removeEventListener('click', el.eventOnClick);

    el.removeAttribute('data-dragging');
  },
};
